import { removeTrapFocus } from '@theme/focus';

const locale = Shopify.locale || 'nl';

function parseQonfiHash(hash) {
  const fragment = hash.replace(/^#/, '');
  if (!fragment.startsWith('qonfi')) return null;
  const queryStr = fragment.split('?')[1] || '';
  return new URLSearchParams(queryStr).get('uuid');
}

function tryOpenQonfi(hash, retries = 0) {
  const uuid = parseQonfiHash(hash);
  if (!uuid) return;
  if (typeof openQonfi === 'function') {
    openQonfi(uuid, 'sidebar', '', locale);
    history.replaceState(null, '', window.location.pathname + window.location.search);
  } else if (retries < 10) {
    setTimeout(() => tryOpenQonfi(hash, retries + 1), 200);
  }
}

// Click interception — dekt desktop nav en mobiel hamburgermenu
document.addEventListener('click', (e) => {
  const link = e.target.closest('a');
  if (!link) return;
  const href = link.getAttribute('href') || '';
  if (!href.includes('#qonfi')) return;
  e.preventDefault();

  const drawer = link.closest('header-drawer');
  if (drawer?.isOpen) {
    drawer.close();
    removeTrapFocus();
  }

  tryOpenQonfi('#' + href.split('#')[1]);
});

// Paginalading met hash al aanwezig (gedeelde link)
function checkHash() {
  if (window.location.hash.startsWith('#qonfi')) {
    tryOpenQonfi(window.location.hash);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkHash);
} else {
  checkHash();
}

// Hash-navigatie via terugknop of gedeelde link
window.addEventListener('hashchange', (e) => {
  const newHash = e.newURL.split('#')[1];
  if (newHash?.startsWith('qonfi')) {
    tryOpenQonfi('#' + newHash);
  }
});
